module.exports = __webpack_public_path__ + "resources/ban-member-f8856b3d2d633ccf05bf135d2cbf4fb0.svg";